import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Add

//Action
import * as configAction from './action/configAction';
import * as revisionAction from './action/revisionAction';
import * as authAction from './action/authAction';
import * as myProfileAction from './action/myProfileAction';
import * as uiAction from './action/uiAction';
import * as notificationAction from './action/notificationAction';

import Backdrop from '@material-ui/core/Backdrop';

//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Popover from '@material-ui/core/Popover';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
//Comp
import Config from './component/Config';
import Auth from './component/Auth';
import MemberInclude from './component/MemberInclude';
import MenuHeader from './component/MenuHeader';
import Home from './component/Home';
import MyProfile from './component/MyProfile';
import MyProfilePreview from './component/MyProfilePreview';
import MyProfileUserEdit from './component/MyProfileUserEdit';
import MyProfilePartnerEdit from './component/MyProfilePartnerEdit';
import MyProfileCommentEdit from './component/MyProfileCommentEdit';
import MyProof from './component/MyProof';
import MyProofPersonAdd from './component/MyProofPersonAdd';
import MyProofAdd from './component/MyProofAdd';
import MyPost from './component/MyPost';
import MyPostEdit from './component/MyPostEdit';
import MyQaQuestion from './component/MyQaQuestion';
import MyQaQuestionEdit from './component/MyQaQuestionEdit';
import MyQaAnswer from './component/MyQaAnswer';
import MyPersonality from './component/MyPersonality';
import MyPersonalityTest28 from './component/MyPersonalityTest28';
import MyPersonalityRelation from './component/MyPersonalityRelation';
import MyKeywordEdit from './component/MyKeywordEdit';
import MyProofWantEdit from './component/MyProofWantEdit';
import MyPhotoMainDirect from './component/MyPhotoMainDirect';
import MyProofPersonDirect from './component/MyProofPersonDirect';
import NewEnd from './component/NewEnd';

import MailGroup from './component/MailGroup';
import MailTalk from './component/MailTalk';
import MailSupport from './component/MailSupport';
import MailDraft from './component/MailDraft';
import Bestpartner from './component/Bestpartner';

import Search from './component/Search';
import FootprintPartner from './component/FootprintPartner';
import FootprintMy from './component/FootprintMy';
import FavoriteMy from './component/FavoriteMy';
import FavoritePartner from './component/FavoritePartner';

import CommunityPost from './component/CommunityPost';
import CommunityQa from './component/CommunityQa';
import CommunityKeyword from './component/CommunityKeyword';

import PartnerProfile from './component/PartnerProfile';

import Memo from './component/Memo';
import PaymentTicketReceiver from './component/PaymentTicketReceiver';
import PaymentTicketSender from './component/PaymentTicketSender';
import CoupleRequestEnd from './component/CoupleRequestEnd';
import CoupleReceptionEnd from './component/CoupleReceptionEnd';
import CoupleRelease from './component/CoupleRelease';

import Help from './component/Help';
import HelpCategory from './component/HelpCategory';

import Campaign from './component/Campaign';


import Articles from './component/Articles';
import ArticlesDetail from './component/ArticlesDetail';

import Setting from './component/Setting';
import SettingCharge from './component/SettingCharge';
import SettingCharged from './component/SettingCharged';
import SettingChargeAutomatic from './component/SettingChargeAutomatic';

import SettingName from './component/SettingName';
import SettingBirthday from './component/SettingBirthday';
import SettingEmail from './component/SettingEmail';
import SettingLoginId from './component/SettingLoginId';
import SettingLoginPass from './component/SettingLoginPass';
import SettingWebpush from './component/SettingWebpush';
import SettingTimeline from './component/SettingTimeline';
import SettingRefusal from './component/SettingRefusal';
import SettingNondisplay from './component/SettingNondisplay';
import SettingTwoFactorAuth from './component/SettingTwoFactorAuth';
import SettingStop from './component/SettingStop';
import SettingOutage from './component/SettingOutage';
import SettingEmailAttestationDirect from './component/SettingEmailAttestationDirect';
import Contact from './component/Contact';
import Lightbox from './component/Lightbox';
import Logout from './component/Logout';
import DialogPartnerOperation from './component/DialogPartnerOperation';
import DialogHelp from './component/DialogHelp';
import DialogGuideProofPerson from './component/DialogGuideProofPerson';
import DialogGuidePayment from './component/DialogGuidePayment';
import DialogGuideApproachMail from './component/DialogGuideApproachMail';
import DialogGuideApp from './component/DialogGuideApp';
import ServiceStopNotAvailable from './component/ServiceStopNotAvailable';

//Icon
import CloseIcon from '@material-ui/icons/Close';

// This site has 3 pages, all of which are rendered
// dynamically in the browser (not server rendered).
//
// Although the page does not ever refresh, notice how
// React Router keeps the URL up to date as you navigate
// through the site. This preserves the browser history,
// making sure things like the back button and bookmarks
// work properly.

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {
  constructor(props) {
    super(props);
  	this.state = {
      loading: false,
  		menuHeaderToggleVisible: false,
      helpVisible: false,
  	}
  }

  _menuHeaderToggle() {
    if (this.state.menuHeaderToggleVisible) {
      this.setState({menuHeaderToggleVisible: false});
    }
    else {
      this.setState({menuHeaderToggleVisible: true});
    }
  }


  render() {

    return (
      <Router basename="/pwa/">
        <Route path="" component={Config} />

        {
          (this.props.config.maintenance === true) ? (
              <div style={{margin:'auto', maxWidth:'400px'}}>
                <div style={{margin:'15px'}}>
                  <div>{this.props.config.maintenanceComment}</div>
                  <div>メンテナンス時間終了後に画面が戻らない場合は再読み込みしてください。</div>
                  <div align='center' style={{margin:'10px'}}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={ () => {
                        this.props.configGet();
                      }}
                    >
                      再読み込み
                    </Button>
                  </div>
                </div>
              </div>
          ): (
            <>
              <Route path="" component={Auth} />
              {
                (this.props.auth.isAuth === true) && (
                  <div>
                    <Route path="" component={MemberInclude} />
                    <Route path="" component={MenuHeader} />

                    {
                      (this.props.my.profile.datetime) && (
                        <div className="centering">
                          <Switch>
                            <Route path="/" exact component={Home} />
                            <Route path="/my/" exact component={MyProfile} />
                            <Route path="/my/preview/" exact component={MyProfilePreview} />
                            <Route path="/my/user/" exact component={MyProfileUserEdit}/>
                            <Route path="/my/partner/" exact component={MyProfilePartnerEdit}/>
                            <Route path="/my/comment/" exact component={MyProfileCommentEdit}/>
                            <Route path="/my/proof/" exact component={MyProof} />

                            <Route path="/my/proof/person" component={MyProofPersonAdd} />
                            <Route path="/my/proof/:type" component={MyProofAdd} />
                            <Route path="/my/post/" exact component={MyPost} />
                            <Route path="/my/post/:id" exact component={MyPostEdit} />
                            <Route path="/my/qa/question/" exact component={MyQaQuestion} />
                            <Route path="/my/qa/question/:id" exact component={MyQaQuestionEdit} />
                            <Route path="/my/qa/answer/" exact component={MyQaAnswer} />

                            <Route path="/my/personality/" exact component={MyPersonality} />
                            <Route path="/my/personality/test28" exact component={MyPersonalityTest28} />
                            <Route path="/my/personality/relation/:type1/:type2/" exact component={MyPersonalityRelation} />

                            <Route path="/my/keyword/" component={MyKeywordEdit} />
                            <Route path="/my/proofWant/" component={MyProofWantEdit} />

                            <Route path="/my/paymentTicketReceiver/" component={PaymentTicketReceiver} />
                            <Route path="/my/paymentTicketSender/" component={PaymentTicketSender} />

                            <Route path="/new/user/" exact component={MyProfileUserEdit}/>
                            <Route path="/new/partner/" exact component={MyProfilePartnerEdit}/>
                            <Route path="/new/comment/" exact component={MyProfileCommentEdit}/>
                            <Route path="/new/photoMainDirect/" exact component={MyPhotoMainDirect} />
                            <Route path="/new/proofPersonDirect/" exact component={MyProofPersonDirect} />
                            <Route path="/new/emailAttestationDirect/" exact component={SettingEmailAttestationDirect} />
                            <Route path="/new/end/" exact component={NewEnd} />

                            <Route path="/mailbox/talk/:pic" exact component={MailTalk} />
                            <Route path="/mailbox/support/" exact component={MailSupport} />
                            <Route path="/mailbox/draft/" exact component={MailDraft} />
                            <Route path="/mailbox/bestpartner/" exact component={Bestpartner} />
                            <Route path="/mailbox/" exact component={MailGroup} />
                            {
                              (this.props.my.setting.serviceStop) ? (
                                <Route path="/search/"  render={ () => (<ServiceStopNotAvailable title="会員検索" />) } />
                              ): (
                                <Route path="/search/" component={Search} />
                              )
                            }
                            <Route path="/bestpartner/" exact component={Bestpartner} />

                            <Route path="/footprint/partner/" component={FootprintPartner} />
                            <Route path="/footprint/my/" component={FootprintMy} />
                            <Route path="/favorite/my/" component={FavoriteMy} />
                            <Route path="/favorite/partner/" component={FavoritePartner} />

                            {
                              (this.props.my.setting.serviceStop) ? (
                                <Route path="/community/post/"  render={ () => (<ServiceStopNotAvailable title="みんなの投稿" />) } />
                              ): (
                                <Route path="/community/post/" component={CommunityPost} />
                              )
                            }
                            {
                              (this.props.my.setting.serviceStop) ? (
                                <Route path="/community/qa/"  render={ () => (<ServiceStopNotAvailable title="みんなのQ&A" />) } />
                              ): (
                                <Route path="/community/qa/" component={CommunityQa} />
                              )
                            }
                            {
                              (this.props.my.setting.serviceStop) ? (
                                <Route path="/community/Keyword/"  render={ () => (<ServiceStopNotAvailable title="みんなのキーワード" />) } />
                              ): (
                                <Route path="/community/keyword/" component={CommunityKeyword} />
                              )
                            }
                            {
                              (this.props.my.setting.serviceStop) ? (
                                <Route path="/partner/:pic"  render={ () => (<ServiceStopNotAvailable title="プロフィール" />) } />
                              ): (
                                <Route path="/partner/:pic" component={PartnerProfile}/>
                              )
                            }

                            <Route path="/coupleRequestEnd/" component={CoupleRequestEnd} />
                            <Route path="/coupleReceptionEnd/" component={CoupleReceptionEnd} />
                            <Route path="/coupleRelease/" component={CoupleRelease} />

                            <Route path="/memo/" component={Memo} />

                            <Route path="/articles/" exact component={Articles} />
                            <Route path="/articles/category-:category" exact component={Articles} />
                            <Route path="/articles/id-:id" component={ArticlesDetail} />

                            <Route path="/campaign/" component={Campaign} />


                            <Route path="/help/" exact component={Help} />
                            <Route path="/help/category_:category" component={HelpCategory} />
                            <Route path={["/contact/", "/contact/:type"]} exact component={Contact} />

                            <Route path="/setting/charge/" component={SettingCharge} />
                            <Route path="/setting/charged/" component={SettingCharged} />
                            <Route path="/setting/chargeAutomatic/" component={SettingChargeAutomatic} />

                            <Route path="/setting/refusal/" component={SettingRefusal} />
                            <Route path="/setting/nondisplay/" component={SettingNondisplay} />
                            <Route path="/setting/name/" component={SettingName} />
                            <Route path="/setting/birthday/" component={SettingBirthday} />

                            <Route path="/setting/loginId/" component={SettingLoginId} />
                            <Route path="/setting/loginPass/" component={SettingLoginPass} />

                            <Route path="/setting/email/" component={SettingEmail} />
                            <Route path="/setting/webpush/" component={SettingWebpush} />
                            <Route path="/setting/timeline/" component={SettingTimeline} />
                            <Route path="/setting/twoFactorAuth/" component={SettingTwoFactorAuth} />


                            <Route path="/setting/stop/" component={SettingStop} />
                            <Route path="/setting/outage/" component={SettingOutage} />

                            <Route path="/setting/" component={Setting} />

                            <Route path="/logout/" component={Logout} />

                          </Switch>
                        </div>
                      )
                    }



                    {
                      (this.props.lightbox.photoList.length > 0) &&
                      <Lightbox />
                    }

                    <DialogPartnerOperation />
                    <DialogHelp />
                    <DialogGuideProofPerson />
                    <DialogGuidePayment />
                    <DialogGuideApproachMail />
                    <DialogGuideApp />
                  </div>
                )
              }

              <Backdrop open={this.props.ui.loading} style={{zIndex:10000}}>
                <CircularProgress color="inherit" />
              </Backdrop>

              <Backdrop open={this.props.ui.progress.visible} style={{zIndex:10000}}>
                <div>
                  <LinearProgress
                    olor="inherit"
                    variant="determinate"
                    style={{width:'280px', height:'20px'}}
                    value={this.props.ui.progress.percent}
                  />

                  <div align='center' style={{color:'#FFF',fontWight:'bold'}}>{ this.props.ui.progress.percent }%</div>
                </div>
              </Backdrop>


              <Dialog
                open={this.props.ui.dialog.visible}
                onClose={ () => this.props.dialogClose() }
                maxWidth={'md'}
                TransitionComponent={Transition}
              >
                <div
                  style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    justifyContent:'space-between',
                  }}
                >
                  <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                    { this.props.ui.dialog.title }
                  </div>
                  <IconButton
                    style={{position:'absolute', top:'0px',right:'0px'}}
                    onClick={ () => this.props.dialogClose() }
                  >
                    <CloseIcon/>
                  </IconButton>
                </div>

                <div style={{margin:'15px'}}>
                  { this.props.ui.dialog.comment }
                </div>
              </Dialog>

              <Snackbar
                open={this.props.ui.snack.visible}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                autoHideDuration={this.props.ui.snack.duration ? this.props.ui.snack.duration : null}
                onClose={() => this.props.snackClose()}
              >
                <Alert
                  severity={this.props.ui.snack.severity}
                  variant="filled"
                  onClose={() => this.props.snackClose()}
                >
                  {this.props.ui.snack.comment}
                  {this.props.ui.snack.link ? <div><Link to={this.props.ui.snack.link}>詳しく</Link></div> : null}
                </Alert>
              </Snackbar>
              <Popover
                open={this.props.ui.popover.visible}
                anchorEl={this.props.ui.popover.anchorEl}
                onClose={() => this.props.popoverClose()}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                <div
                  style={{
                    padding:'10px',
                    background: '#666',
                    color:'#fff',
                    fontSize:'0.9em',
                  }}
                >
                  {this.props.ui.popover.comment}
                </div>
              </Popover>
            </>
          )
        }

      </Router>

    )

  }
}
const mapStateToProps = (state) => {
	return {
    config: state.config,
    auth: state.auth,
    notification: state.notification,
    ui: state.ui,
    lightbox: state.lightbox,
    my: state.my,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...configAction,
    ...revisionAction,
		...authAction,
    ...myProfileAction,
    ...uiAction,
    ...notificationAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
